import React from 'react';
import { ThemeProvider } from 'styled-components';
import { lightTheme } from './utils/theme';
import { GlobalStyles } from './utils/global';
import { ToastContainer } from 'react-toastify';
import PrivacyPolicy from './pages/privacy-policy'
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const themeMode = lightTheme;

  return (
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      {/* <Router /> */}
      <PrivacyPolicy />
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
